export type BalineseHoliday = {
  date: string;
  name: string;
  nameEn: string;
  kind: "nyepi" | "galungan" | "kuningan";
  noteDe: string;
  noteEn: string;
};

/**
 * Bewegliche balinesische Feiertage (Caka- und Pawukon-Kalender).
 * Quelle: bali.com / Wikipedia – Stand 2026–2030.
 */
export const BALINESE_HOLIDAYS: BalineseHoliday[] = [
  {
    date: "2026-03-19",
    name: "Nyepi",
    nameEn: "Nyepi",
    kind: "nyepi",
    noteDe: "Tag der Stille – die ganze Insel ruht",
    noteEn: "Day of Silence – the whole island shuts down",
  },
  {
    date: "2026-06-17",
    name: "Galungan",
    nameEn: "Galungan",
    kind: "galungan",
    noteDe: "Wichtigster religiöser Feiertag Balis",
    noteEn: "Bali's most important religious holiday",
  },
  {
    date: "2026-06-27",
    name: "Kuningan",
    nameEn: "Kuningan",
    kind: "kuningan",
    noteDe: "10 Tage nach Galungan",
    noteEn: "10 days after Galungan",
  },
  {
    date: "2027-01-13",
    name: "Galungan",
    nameEn: "Galungan",
    kind: "galungan",
    noteDe: "Wichtigster religiöser Feiertag Balis",
    noteEn: "Bali's most important religious holiday",
  },
  {
    date: "2027-01-23",
    name: "Kuningan",
    nameEn: "Kuningan",
    kind: "kuningan",
    noteDe: "10 Tage nach Galungan",
    noteEn: "10 days after Galungan",
  },
  {
    date: "2027-03-09",
    name: "Nyepi",
    nameEn: "Nyepi",
    kind: "nyepi",
    noteDe: "Tag der Stille – die ganze Insel ruht",
    noteEn: "Day of Silence – the whole island shuts down",
  },
  {
    date: "2027-08-11",
    name: "Galungan",
    nameEn: "Galungan",
    kind: "galungan",
    noteDe: "Wichtigster religiöser Feiertag Balis",
    noteEn: "Bali's most important religious holiday",
  },
  {
    date: "2027-08-21",
    name: "Kuningan",
    nameEn: "Kuningan",
    kind: "kuningan",
    noteDe: "10 Tage nach Galungan",
    noteEn: "10 days after Galungan",
  },
  {
    date: "2028-03-08",
    name: "Galungan",
    nameEn: "Galungan",
    kind: "galungan",
    noteDe: "Wichtigster religiöser Feiertag Balis",
    noteEn: "Bali's most important religious holiday",
  },
  {
    date: "2028-03-18",
    name: "Kuningan",
    nameEn: "Kuningan",
    kind: "kuningan",
    noteDe: "10 Tage nach Galungan",
    noteEn: "10 days after Galungan",
  },
  {
    date: "2028-03-26",
    name: "Nyepi",
    nameEn: "Nyepi",
    kind: "nyepi",
    noteDe: "Tag der Stille – die ganze Insel ruht",
    noteEn: "Day of Silence – the whole island shuts down",
  },
  {
    date: "2028-10-04",
    name: "Galungan",
    nameEn: "Galungan",
    kind: "galungan",
    noteDe: "Wichtigster religiöser Feiertag Balis",
    noteEn: "Bali's most important religious holiday",
  },
  {
    date: "2028-10-14",
    name: "Kuningan",
    nameEn: "Kuningan",
    kind: "kuningan",
    noteDe: "10 Tage nach Galungan",
    noteEn: "10 days after Galungan",
  },
  {
    date: "2029-03-15",
    name: "Nyepi",
    nameEn: "Nyepi",
    kind: "nyepi",
    noteDe: "Tag der Stille – die ganze Insel ruht",
    noteEn: "Day of Silence – the whole island shuts down",
  },
  {
    date: "2029-05-02",
    name: "Galungan",
    nameEn: "Galungan",
    kind: "galungan",
    noteDe: "Wichtigster religiöser Feiertag Balis",
    noteEn: "Bali's most important religious holiday",
  },
  {
    date: "2029-05-12",
    name: "Kuningan",
    nameEn: "Kuningan",
    kind: "kuningan",
    noteDe: "10 Tage nach Galungan",
    noteEn: "10 days after Galungan",
  },
  {
    date: "2029-11-28",
    name: "Galungan",
    nameEn: "Galungan",
    kind: "galungan",
    noteDe: "Wichtigster religiöser Feiertag Balis",
    noteEn: "Bali's most important religious holiday",
  },
  {
    date: "2029-12-08",
    name: "Kuningan",
    nameEn: "Kuningan",
    kind: "kuningan",
    noteDe: "10 Tage nach Galungan",
    noteEn: "10 days after Galungan",
  },
  {
    date: "2030-03-05",
    name: "Nyepi",
    nameEn: "Nyepi",
    kind: "nyepi",
    noteDe: "Tag der Stille – die ganze Insel ruht",
    noteEn: "Day of Silence – the whole island shuts down",
  },
  {
    date: "2030-06-26",
    name: "Galungan",
    nameEn: "Galungan",
    kind: "galungan",
    noteDe: "Wichtigster religiöser Feiertag Balis",
    noteEn: "Bali's most important religious holiday",
  },
  {
    date: "2030-07-06",
    name: "Kuningan",
    nameEn: "Kuningan",
    kind: "kuningan",
    noteDe: "10 Tage nach Galungan",
    noteEn: "10 days after Galungan",
  },
];

/** Alle Feiertage ab einem Datum (ISO), aufsteigend sortiert. */
export function upcomingBalineseHolidays(fromIso: string): BalineseHoliday[] {
  return BALINESE_HOLIDAYS.filter((h) => h.date >= fromIso).sort((a, b) =>
    a.date.localeCompare(b.date)
  );
}

/** Fertiger Sperr-Grund für die Backstage-Tabelle. */
export function holidayReason(h: BalineseHoliday): string {
  return `${h.name} – Bali Holiday`;
}